
document.querySelectorAll('.product-block').forEach(product => {
  const productLink = product.querySelector('.product-link')
  productLink.addEventListener('click', e => {
    e.preventDefault();
    let productID = product.getAttribute('data-product-id')

    $(`.modal[data-product-id="${productID}"]`).modal()
  })

  document.addEventListener('theme:cartchanged', e => {
    $('.modal.show').each(function() {$(this).modal('hide')})
  })
})